import React from 'react';
import { cx } from '@emotion/css';
import { useWizardStyles } from './Wizard.styles';
export function Wizard(props) {
    const classes = useWizardStyles(props);
    return (React.createElement("div", { className: cx(props.className, classes.container), id: props.id },
        React.createElement("div", { className: classes.leftContent }, props.sideNavSection),
        React.createElement("div", { className: classes.rightContent },
            React.createElement("div", { className: classes.mainContent }, props.children),
            React.createElement("div", null, props.navigationSection))));
}
//# sourceMappingURL=Wizard.js.map